export default {
	termsAndConditions: {
		lastUpdate: 'Pēdējo reizi atjaunināts: 2024. gada 10. jūnijā',
		content: `
		<p>Tālāk norādītie noteikumi ir svarīgi, jo:</p>
		<ul>
			<li>Viņi nosaka savas likumīgās tiesības vietnē {siteName}.</li>
			<li>Paskaidrojiet, kādas tiesības mums piešķirat, izmantojot vietni {siteName}.</li>
			<li>
				Tajos ir aprakstīti noteikumi, kas ikvienam ir jāievēro, izmantojot vietni {siteName}.
			</li>
		</ul>
		<p>
			Lūdzu, uzmanīgi izlasiet šos noteikumus, kā arī mūsu {privacyPolicyLink} un jebkuru citu
			šajos Noteikumos minētie dokumenti.
		</p>
		<p>Sāksim...</p>
		<h3>1. IEVADS UN DATI PAR {siteNameUpper}.</h3>
		<p>
			Vietne {websiteLink} (turpmāk tekstā "Tīmekļa vietne") pieder uzņēmumam
			{siteName} S.L (turpmāk tekstā “{siteName}”), uzņēmums
			iekļauts saskaņā ar Spānijas tiesību aktiem ar adresi Avenida de
			Cerdanyola, nº 75, 1º, Sant Cugat del Vallès (Barselona), CIF numura īpašnieks
			B-56.768.260 un reģistrēts Barselonas preču reģistrā sējumā
			49065, Folio 0033, lapa B-606324, 1. reģistrācija.
		</p>
		<p>
			{siteName} nodod vietni jūsu rīcībā, lai jūs varētu tajā nokļūt
			pazīstiet mūs labāk, pārziniet mūsu sniegtos pakalpojumus un, ja vēlaties, varat sazināties
			un, ja nepieciešams, noslēdziet ar mums līgumu.
		</p>
		<h3>2. LIETOŠANAS NOTEIKUMU MĒRĶIS UN PIEMĒROŠANAS JOMA</h3>
		<p>
			Šie lietošanas nosacījumi kopā ar {privacyPolicyLink} un
			{cookiesPolicyLink}, tiesiskais regulējums, kas regulē vietnes izmantošanu
			{websiteLink}. Šie lietošanas nosacījumi jums būs pieejami vietnē
			angļu valodā, lai jūs jebkurā laikā varētu tos konsultēties, arhivēt vai izdrukāt un
			kad vien tu vēlies.
		</p>
		<p>
			Lai uzzinātu visus jautājumus par {siteName} veikto ārstēšanu.
			no saviem personas datiem, lūdzu, apmeklējiet mūsu {privacyPolicyLink} un mūsu {cookiesPolicyLink}.
			Abas politikas jums būs pieejamas arī angļu valodā, lai jūs varētu to darīt
			konsultējieties, arhivējiet vai izdrukājiet tos jebkurā laikā.<br />
			{siteName} vietnē izmanto trešās puses sīkfailus. Lai uzzinātu vairāk
			par tīmeklī {websiteLink} izmantoto sīkfailu veidu, to mērķi un veidu
			lai konfigurētu savu pārlūkprogrammu, ja nevēlaties, lai mēs izmantojam šīs sīkdatnes,
			lūdzu, apmeklējiet mūsu {cookiesPolicyLink}.
		</p>
		<p>
			Gan šie lietošanas nosacījumi, gan {privacyPolicyLink} un 
			{cookiesPolicyLink} ir sagatavoti saskaņā ar spēkā esošajiem noteikumiem
			piemērojamie noteikumi, cita starpā, Likums 34/2002 par pakalpojumiem
			Informācijas sabiedrība un elektroniskā komercija un Regula (ES) 2016/679
			Eiropas Parlamenta un Padomes 2016. gada 27. aprīļa lēmumu par
			fizisko personu aizsardzība attiecībā uz personas datu apstrādi
			datus un šo datu brīvu apriti un ar ko Direktīva 95/46/EK
			ir atcelts.
		</p>
		<h3>3. PIEKĻUVE TĪMEKĻA VIETNEI UN PIEKRĪŠANA</h3>
		<p>
			Piekļuve vietnei ir bezmaksas, izņemot to daļu, kas saistīta ar vietnes izmaksām
			savienojums, izmantojot interneta nodrošināto telekomunikāciju tīklu
			piekļuves nodrošinātājs, ar kuru esat noslēdzis līgumu. Jūs varat brīvi pārlūkot vietni
			un piekļūstiet tai tik reižu, cik vēlaties. Lai piekļūtu vietnei un tajā pārvietotos,
			Jums nav jāreģistrējas, izņemot, ja vēlaties nolīgt pakalpojumu.
		</p>
		<p>
			Vietnes izmantošana sniedz jums vietnes lietotāja stāvokli
			(turpmāk tekstā "Lietotājs"), un tas nozīmē, ka jūs pilnībā un bez ierunām piekrītat
			šie lietošanas nosacījumi, kā arī {privacyPolicyLink} un {cookiesPolicyLink}
			no tīmekļa vietnes. Turklāt jūs piekrītat neizmantot Pakalpojumu nelikumīgiem nolūkiem
			mērķiem.
		</p>
		<p>
			Piekļūstot vietnei un to pārlūkojot, jūs apliecināt, ka jūsu
			atbildība par to, ka esat pilngadīgs un ka jums ir nepieciešamās juridiskās prasības
			spēju piekļūt Vietnei un to izmantot, arī paziņojot, ka jūs pilnībā
			saprast un pieņemt šos lietošanas nosacījumus bez ierunām.
		</p>
		<p>
			No otras puses, informējam, ka juridisku iemeslu dēļ mēs arhivējam
			elektroniskie dokumenti, kuros noformēti pirkumi. Jūs varat piekļūt
			šos dokumentus jebkurā laikā, pieprasot tos vietnē: {supportLink}.
		</p>
		<h3>4. VIETNES LIETOŠANAS NOSACĪJUMI</h3>
		<p>
			Lietotājs piekrīt lietot Vietni saskaņā ar šiem lietošanas noteikumiem,
			spēkā esošie tiesību akti un labticība. Tādējādi Lietotājs atbildēs uz {siteName}.
			 un jebkurai trešajai pusei par zaudējumiem un zaudējumiem, kas radušies no
			izmantošana, kas ir pretrunā šiem nosacījumiem, tiesību aktiem un labticībai
			ko veic Vietnes lietotājs.
		</p>
		<h3>5. PAKALPOJUMA APRAKSTS</h3>
		<p>
			Izmantojot Pakalpojumu, vietne {siteName} ļauj abonēt pakalpojumu uz
			veikt attēlu rediģēšanu.
		</p>
		<p>
			Valoda, kurā ir noslēgts līgums starp {siteName} un pircēju
			tiks noslēgts, būs izcelsmes valsts.<br />
			Pirkšanas process tiešsaistes pakalpojumā būs šāds:
		</p>
		<ol>
			<li>Jums ir jāreģistrējas vietnē, izmantojot lietotājvārdu un paroli.</li>
			<li>
				Reģistrācijas brīdī lietotājam ir jāizvēlas viens no maksājumu plāniem
				atrodami sadaļā Cenas un tiks piešķirti kredīti atkarībā no
				izvēlētais plāns. Katrs kredīts ļaus jums rediģēt vienu attēlu.
			</li>
			<li>
				Pēc pakalpojuma iegādes lietotājam būs administrācija
				panelis, kurā viņi atradīs:
				<ul>
					<li>
						Sadaļa ar visu apstrādāto attēlu sarakstu
						var rediģēt to tik reižu, cik vēlaties, un lejupielādēt to savā
						ierīci.
					</li>
					<li>
						Plānu un maksājumu sadaļa, lai skatītu rēķinus un atceltu
						abonementu.
					</li>
					<li>Sadaļa Mans konts, lai varētu mainīt konta preferences.</li>
				</ul>
			</li>
		</ol>
		<p>
			Kad pakalpojuma pirkums būs veikts, tas tiks apstiprināts līdz
			ne ilgāk kā 24 stundu laikā nosūtot e-pastu uz jūsu norādīto adresi
			norādīts. Tajā tiks norādīts pakalpojums, kā atcelt abonementu, tā
			summa, piemērojamie nodokļi, maksājuma veids un piemērojamie noteikumi un
			nosacījumiem.
		</p>
		<h4>5.1 abonements</h4>
		<p>
			Pakalpojuma abonements mainās atkarībā no izvēlētā plāna un būs
			automātiski tiek atjaunots uz tādu pašu laika periodu līdz tā izbeigšanai.
			Ja vien neatceļat savu abonementu, jūs pilnvarojat mūs ielādēt
			atbilstošo gada abonēšanas maksu jūsu maksājuma veidā.
		</p>
		<p>
			Jūs jebkurā laikā varat atcelt savu Pakalpojuma abonementu, un jūs to darīsit
			joprojām varēsiet tai piekļūt līdz gada norēķinu perioda beigām. Uz
			likumā atļautajā apmērā maksājumi nav atmaksājami, un mēs to nenodrošinām
			kompensācijas vai kredīti par daļējiem gada abonēšanas periodiem.
		</p>
		<h3>6. CENA UN NODOKĻI</h3>
		<p>
			Vietnē {siteName} piedāvāto produktu cenas ir norādītas eiro
			(€) vai tās valsts valūta, no kuras tiek veikts pirkums, Vērtība
			Pirkšanas brīdī spēkā esošais pievienotais nodoklis (PVN) tiek aplikts ar preču cenu
			produktiem.
		</p>
		<p>
			Jebkurā gadījumā darbība varētu būt atbrīvota no nodokļa vai arī bez PVN atkarībā no
			jūsu dzīvesvietas valsts vai apstākļi, kādos jūs rīkojaties. Šī iemesla dēļ,
			dažos gadījumos pasūtījuma galīgā cena var tikt mainīta attiecībā uz
			parādīts viens.<br />
			No PVN maksāšanas atbrīvoto subjektu veiktos pirkumus norādīs līdz
			nosūtot savu PVN/NIF numuru pa e-pastu uz {supportLink}, nevis ierakstot
			pirkumi ar minēto nodokli.
		</p>
		<h3>7. MAKSĀJUMA VEIDS</h3>
		<p>
			Tiešsaistes maksājumu par iegādāto pakalpojumu var veikt ar kredītkarti vai debetkarti.
			Šajā ziņā vietne {siteName} informē kredītkaršu un debetkaršu īpašniekus
			darījumi interneta veikalā tiek veikti, izmantojot drošu maksājumu
			vārteja, izmantojot SSL tehnoloģiju, lai garantētu datu pārraides drošību.
		</p>
		<h3>8. ATTEIKŠANAS UN ATMAKSAS TIESĪBAS</h3>
		<h4>8.1. Atteikuma tiesības</h4>
		<p>
			Ņemot vērā mūsu tiešsaistes pakalpojumā tirgoto produktu veidu, programmatūra digitālā formātā
			QR formātā, atteikuma tiesības nebūs piemērojamas saskaņā ar
			Karaļa 16. novembra likumdošanas dekrēta 1/2007 103. panta m) apakšpunkts līdz plkst.
			the ka pārstrādātais Vispārīgā patērētāju aizsardzības likuma teksts un
			Lietotāji un citi papildu likumi ir apstiprināti.
		</p>
		<h4>8.2. Atmaksas</h4>
		<p>
			Neatkarīgi no lietotāja izvēlētā plāna, lietotāja maksātās summas un uz
			likumā atļautajā apmērā netiks atmaksāta.
		</p>
		<p>
			Līgumā paredzēto pakalpojumu nedrīkst piešķirt vai nodot citiem lietotājiem
			serviss.
		</p>
		<p>
			Jebkurā gadījumā lietotājs var izmantot līgumā paredzēto pakalpojumu līdz gada beigām
			līgumā noteiktais periods.
		</p>
		<h3>9. PIEDĀVĀJUMU DERĪGUMS</h3>
		<p>
			Pakalpojumā piedāvātie pakalpojumi un to cenas būs pieejami par
			iegādājieties, kamēr tie atrodas pakalpojumu katalogā, kas tiek parādīts, izmantojot šo
			tīmekļa vietne.
		</p>
		<p>
			Jebkurā gadījumā vietne {siteName} patur tiesības tajā veikt izmaiņas
			uzskata par piemērotu Pakalpojumā, spējot atjaunināt produktus un pakalpojumus
			atkarībā no tirgus.
		</p>
		<p>
			{siteName} patur tiesības mainīt cenas bez iepriekšēja brīdinājuma. Mēs
			informēt jūs, ka neskatoties uz atjauninājumiem, kas tiek veikti, lai cenas
			pakalpojums, tajos var būt kļūdas. Mēs nekavējoties izlabosim visas kļūdas
			parādās, taču tie nebūs Pakalpojumam saistoši.
		</p>
		<h3>10. DROŠĪBA</h3>
		<p>
			Kā norādīts iepriekš, visa pirkuma procedūra, kā arī pārraide
			Jūsu personas datu un maksājumu sistēmas, tiek veikta drošā lapā un
			šifrētā veidā, izmantojot SSL protokolu.
		</p>
		<p>
			Mēs garantējam Pakalpojuma drošību saskaņā ar spēkā esošajiem
			tehnoloģiskās zināšanas. Tomēr {siteName} nevar garantēt pilnīgu
			Pakalpojuma turpmākā drošība. Jebkurā gadījumā mēs apsolām labot un
			īstenot atbilstošus korektīvos pasākumus, lai labotu iespējamo nodrošinājumu
			pārkāpums, cik drīz vien iespējams.
		</p>
		<p>
			Jūs piekrītat paziņot vietnei {siteName} nekavējoties un pa e-pastu {supportLink}
			par jebkuru situāciju, kas varētu novest pie uzdošanās par lietotāja identitāti.
		</p>
		<h3>11. MODIFIKĀCIJAS UN NESĒKUMS</h3>
		<p>
			Mēs varam atjaunināt Pakalpojuma noteikumus un nosacījumus arī turpmāk
			kā paša Pakalpojuma iespējas un funkcijas.
		</p>
		<p>
			Par noteikumu un nosacījumu izmaiņām informēsim, ievietojot paziņojumu
			redzamā vietā mūsu tīmekļa vietnē un/vai pa e-pastu.
		</p>
		<p>
			Ja tiek deklarēts kāds šajos noteikumos ietvertais punkts, pilnībā vai
			daļēji, neesošs vai neefektīvs, tas ietekmēs tikai minēto noteikumu vai daļu
			no tā, kas ir nulles vai neefektīva. Noteikumi un nosacījumi būs spēkā
			viss pārējais, kam ir šāds nodrošinājums, vai tā daļa, kuru ietekmē
			netiek ievietots.
		</p>
		<h3>12. PRASĪBAS UN DARBĪBAS, KAS IZCELTAS NO LĪGUMA</h3>
		<p>
			Cik vien iespējams, šo pakalpojumu regulē Spānijas tiesību akti.<br />
			Lai vienkāršotu prasību risināšanu civilprocesa kārtībā un
			samazināt izmaksas, mēs neizslēdzam iespēju pakļauties an
			Tirdzniecības palātu šķīrējtiesas kapitāla šķīrējtiesa un
			Rūpniecība. Šajā ziņā un saskaņā ar piemērojamiem noteikumiem
			 {siteName} informē par Eiropas tiešsaistes strīdu izšķiršanas sistēmu
			platforma, kas atvieglo šādu strīdu ārpustiesas izšķiršanu
			līgumus, kas noslēgti tiešsaistē starp patērētājiem un interneta pakalpojumu
			pakalpojumu sniedzēji. Šai platformai var piekļūt, izmantojot šādu vietni:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. INTELEKTUĀLĀ UN RŪPNIECISKĀ ĪPAŠUMA TIESĪBAS</h3>
		<p>
			Vietnei un tās saturam tiek piemērota aizsardzība
			pašreizējie valsts noteikumi par intelektuālo un/vai rūpniecisko īpašumu, kā
			kā arī piemērojot tajās piemērojamās starptautiskās konvencijas
			jautājumiem. {siteName} ir īpašnieks vai ir pienācīgi licencējis visu
			Intelektuālā un rūpnieciskā īpašuma tiesības uz vietni un tās saturu.
		</p>
		<p>
			Jebkāda veida reproducēšana, izplatīšana, publiska komunikācija, transformācija,
			darīt pieejamu un vispār jebkura cita izmantošanas darbība neatkarīgi no tā, vai tā ir vai nav
			Vietnes vai tās satura komerciālos nolūkos, bez iepriekšēja
			izteiktu vietnes {siteName} piekrišanu. Ir skaidri aizliegts dzēst
			identificējot vietnes {siteName} datus kā Intelektuālā īpašuma un
			Vietnes vai tās satura rūpnieciskā īpašuma tiesības.
		</p>
		<p>
			{siteName} patur visas intelektuālā un rūpnieciskā īpašuma tiesības
			pār Vietni un tās saturu, kā arī paturot tiesības īstenot jebkuru juridisku
			darbības, kas tai atbilst, lai pārtrauktu, novērstu vai sauktu pie atbildības
			Vietnes vai tās satura nelikumīga izmantošana. Nekādā gadījumā un zem nr
			apstākļi nodrošina Lietotāja vai trešās personas piekļuvi Vietnei vai tās izmantošanu
			puses veido vai norāda uz jebkāda veida {siteName} nodevu
			Vietnes vai tās satura intelektuālā vai rūpnieciskā īpašuma tiesības.
			Nekādā gadījumā vietne {siteName} neprasa pārtraukt vietnes izmantošanu
			Vietne vai tās nelikumīgs saturs vai saturs, kas ir pretrunā šiem nosacījumiem, var būt
			tiek saprasta kā {siteName} klusējot izteikta piekrišana šādiem lietojumiem vai atteikšanās
			par jebkuru tai atbilstošu juridisku darbību.
		</p>
		<h3>14. PIENĀKUMI UN GARANTIJAS</h3>
		<p>
			Lietotājam ir jāizmanto Vietne un tās saturs saskaņā ar
			šo lietošanas nosacījumu, spēkā esošo tiesību aktu un labticības nosacījumus. Jebkurš
			tīmekļa vietnes vai tās satura izmantošana pretrunā šiem vispārējiem noteikumiem,
			likums vai laba ticība ir nepārprotami aizliegta neatkarīgi no tā, vai šāda izmantošana ir bijusi
			ekonomisks mērķis vai nē.<br />
			Lietotājs būs atbildīgs par jebkādiem bojājumiem vai kaitējumu, kas nodarīts vietnei {siteName}
			 vai trešajām personām, kas tieši vai netieši iegūtas no jebkādas izmantošanas
			ko Lietotājs izmanto Vietnē vai tās saturā pretēji šiem noteikumiem
			nosacījumus, likumu, morāli, sabiedrisko kārtību vai labticību.
		</p>
		<p>
			Lai vietne un tās saturs būtu pieejams Lietotājam, {siteName}
			 nepieciešami trešo pušu sniegtie pakalpojumi. Iespējams, ka
			neskatoties uz uzņēmuma {siteName} centieniem nodrošināt vietni pieejamu
			un pieejama lietotājiem, tā pieejamība var tikt apturēta, pārtraukta vai
			atcelts citu iemeslu dēļ, kas nav saistīti ar vietni {siteName}. Tāpēc {siteName}
			negarantē pārtraukumu vai kļūdu neesamību, piekļūstot
			Vietne vai tās saturs, kā arī tas, ka tie tiek atjaunināti vai vienmēr tiek rādīti
			to jaunākā versija. Līdz ar to {siteName} noraida jebkuru
			atbildība par zaudējumiem, kas var tikt nodarīti Lietotājam vai trešajām personām kā
			apturēšanas, pārtraukuma, nepārtrauktības trūkuma, tīkla pārtraukuma rezultāts
			vai vietnes atvienošana.
		</p>
		<p>
			{siteName} nekādā gadījumā un nekādos apstākļos nebūs atbildīgs
			bojājumi vai zaudējumi, kas lietotājam radušies tādu iemeslu dēļ, kas nav attiecināmi uz {siteName}
			 piemēram, kā piemēru un nekādā gadījumā neierobežojot, dabiski
			katastrofas, nepārvaramas varas vai ārkārtējas steidzamības situācijas, vīrusi, kaitīgi
			komponenti, pārlūkprogrammas darbības traucējumi, tīkla pārtraukumi, datora ielaušanās vai
			trešo pušu uzbrukumi.
		</p>
		<h3>15. SAITES</h3>
		<p>
			Vietnes, platformas, forumi, tērzēšana, emuāri vai ārējie sociālie tīkli, kas
			saitei vai saitei uz vietni ir skaidri jānorāda, ka viņiem nav
			vietnes {siteName} autorizācija vai uzraudzība un minētā saistīšana vai
			saite neietver, nepieņem vai nenorāda uz jebkāda veida saistību starp {siteName}
			 un tīmekļa vietnes, platformas, forumi, tērzēšana, emuāri vai ārējie
			sociālie tīkli, kuros ir saite vai saite uz vietni.
		</p>
		<p>
			Jebkurā gadījumā jebkurai saitei, kas ir paredzēta vietnei, ir jābūt vērstai
			tieši uz vietnes sākumlapu vai sākumlapu, noklikšķinot uz URL
			tīmekļa vietnes, kas aptver visu sākumlapas ekrānu vai sākuma lapu
			vietni, lai saite būtu absolūta un pilnīga, neizmantojot
			rāmji, rāmji vai hipersaites. {siteName} nekādā gadījumā neatbild
			un jebkuros apstākļos uz saturu, informāciju vai datiem, kas saistīti ar
			vietni, tās saturu vai jebkuru citu informāciju, kas ietverta vietnēs, platformās,
			forumos, tērzēšanas sarunās, emuāros vai trešo pušu sociālajos tīklos, kuros ir saite vai saite uz
			Tīmekļa vietne.
		</p>
		<p>
			Ir nepārprotami aizliegts izveidot saiti vai saites uz vietni no vietnēm,
			platformas, forumi, tērzēšana, emuāri vai sociālie tīkli, kas ir pretrunā ar likumu, morāli
			un labas paražas, īpaši ar pornogrāfiskām, nelegālām, nelegālām vai
			saturs, kas pārkāpj cilvēktiesības.
		</p>
		<p>
			No otras puses, vietne var saturēt saites uz trešo pušu vietnēm,
			platformās, forumos, tērzēšanas sarunās, emuāros vai sociālajos tīklos. {siteName} nav
			ir cilvēkresursi un/vai tehniskie līdzekļi, lai zinātu vai kontrolētu informāciju un
			saturs, kas tiek rādīts trešo pušu vietnēs. Tāpēc {siteName} nekādā gadījumā
			 būt atbildīgs par saistīto vietņu saturu un saskaņā ar Nr
			Apstākļos minētās saites var uzskatīt par efektīvām satura zināšanām
			no vietnēm, uz kurām tās ir saistītas.
		</p>
		<h3>16. DATU AIZSARDZĪBA</h3>
		<p>
			Kā noteikts savā {privacyPolicyLink}, {siteName} apņemas izmantot Lietotāju
			datus, ievērot to konfidencialitāti un izmantot tos saskaņā ar
			ārstēšanas mērķi, kā arī ievērot savu pienākumu to saglabāt.
			un pielāgot visus pasākumus, lai izvairītos no izmaiņām, nozaudēšanas, apstrādes vai neatļautas
			piekļuve saskaņā ar spēkā esošo tiesību aktu noteikumiem par
			personas datu aizsardzība.
		</p>
		<p>
			Vietne ietver atbilstošus drošības pasākumus un izmanto nozares standartus
			tehnoloģija, lai uzlabotu drošību, integritāti, pilnīgumu, precizitāti un
			personas datu aizsardzību, ko tā ir savākusi un noteikusi
			saprātīgus piesardzības pasākumus, lai aizsargātu šo informāciju no iespējamiem zaudējumiem vai
			ļaunprātīga izmantošana. Tās noteikumi par datu aizsardzību un drošību tiek periodiski pārskatīti
			un vajadzības gadījumā uzlabo, un tā cenšas nodrošināt, ka tikai pilnvarotie
			personas var piekļūt Lietotāja sniegtajai informācijai.
		</p>
		<p>
			Lai uzzinātu vairāk par pārvaldību un ārstēšanu, ko veic {siteName}
			 no saviem datiem, lūdzu, izlasiet mūsu {privacyPolicyLink} un mūsu {cookiesPolicyLink}.
		</p>
		<h3>17. ILGUMS UN MODIFIKĀCIJA</h3>
		<p>
			Šie lietošanas nosacījumi būs spēkā tik ilgi, kamēr tie ir pakļauti
			lietotājiem, lai, tiklīdz tie ir pilnībā vai daļēji pārveidoti vai atjaunināti,
			šie nosacījumi vairs nebūs spēkā, jo tie ir jaunie lietošanas nosacījumi
			tie, kas tālāk regulē Vietnes lietošanu.
		</p>
		<p>
			{siteName} patur tiesības tos pārskatīt, mainīt vai atjaunināt
			lietošanas nosacījumus jebkurā laikā. Jebkādu izmaiņu gadījumā šajos nosacījumos
			izmantošana jebkāda iemesla dēļ, {siteName} informēs lietotājus mājaslapā par
			tīmeklī par minēto apstākli, lai viņi būtu pienācīgi informēti un varētu konsultēties
			pašreizējo lietošanas nosacījumu pārskatīšanu, modifikāciju vai atjauninājumu
			jūsu apmierinātība.
		</p>
		<h3>18. VISPĀRĪGI</h3>
		<p>
			Nekādā gadījumā un nekādos apstākļos nedrīkst izmantot jūsu tiesības
			{siteName} ir jāsaprot kā atteikšanās no tiem.
		</p>
		<p>
			Šajos nosacījumos ietvertie virsraksti ir tikai orientējoši vai
			informatīvi, lai tie neietekmētu, kvalificētu vai paplašinātu interpretāciju
			no tiem.
		</p>
		<p>
			Gadījumā, ja kāds no šajos nosacījumos ietvertajiem punktiem būtu bijis
			tiesa atzinusi par spēkā neesošu, ļaunprātīgu vai neizpildāmu, pilnībā vai daļēji
			vai administratīvā iestāde, minētā deklarācija individuāli ietekmēs klauzulu
			uzskatot to par nederīgu un nepaziņojot par spēkā neesošu, ļaunprātīgu izmantošanu vai
			nepiemērojamība jebkādos apstākļos tiek attiecināta uz pārējo
			nosacījumus, kas pastāvēs.
		</p>
		<p>
			Šie lietošanas nosacījumi, kā arī {privacyPolicyLink} un {cookiesPolicyLink}
			uz tiem vienmēr attiecas pašreizējie Spānijas noteikumi.
		</p>
		<h3>19. KLIENTU APKALPOŠANA</h3>
		<p>
			Lai saņemtu paskaidrojumus, incidentus vai pretenzijas, varat sazināties ar mums, izmantojot:<br />
			E-pasts: {supportLink}<br />
			Pasta adrese: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barselona, Spānija.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Pēdējo reizi atjaunināts: 2024. gada 10. jūnijā',
		content: `
			<h3>1. Atbildīgā puse un apraksts</h3>
			<h5>1.1. Atbildīgs</h5>
			<p>Par šīs vietnes apstrādi atbildīgā persona ir Remove Background S.L (tālāk tekstā Remove Background 
			vai Pakalpojums), ar adresi Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barselona, Spānija.</p>
			<p>NIF: B56768260<br> E-pasts: {supportLink}</p>

			<h5>1.2. Apraksts</h5>
			<p>Nepieciešams nosacījums ir piekrišana pakalpojuma Remove Background konfidencialitātes politikai (turpmāk "Privātuma politika"). 
				par mūsu tīmekļa vietnes lietošanu un pakalpojuma (turpmāk tekstā "Pakalpojums") sniegšanu.<br>
				Šī privātuma politika regulē jūsu personiskās un nepersoniskās informācijas vākšanu, apstrādi un izmantošanu 
				kā Noņemt fonu lietotājs, sākot no spēkā stāšanās datuma, kas tiek rādīts galvenē.<br>
				Lai apstrādātu jūsu personas datus, Remove Background atbilst spēkā esošajiem vietējiem un Eiropas tiesību aktiem, 
				kā arī tās īstenošanas noteikumiem.</p>


			<h3>2. Savāktā informācija</h3>
			<p>Piekļuvi mūsu vietnei var nodrošināt bez nepieciešamības sniegt nekādu informāciju, lai gan jāreģistrējas un/ 
				vai noslēgt līgumu par mūsu plāniem, jums būs jāsniedz mums zināma personiskā informācija. Informācija (personīga 
				vai nepersoniska), ko ievāc Pakalpojums, var atšķirties atkarībā no tā.<br>
				Pakalpojuma apkopotā personiskā un nepersoniskā informācija pie mums nonāks trīs veidos: 1) tā, kura 
				tiek savākti automātiski 2) to, ko jūs mums sniedzat brīvprātīgi, un 3) to, ko nodrošina trešās puses.</p>

			<h5>2.1. Automātiski savāktais</h5>
			<p>Šajā informācijā būs:</p>
			<ul>
				<li>Tā, kas tiek savākta, izmantojot sīkfailus vai līdzīgus mehānismus, kas saglabāti jūsu ierīcē, vienmēr ar jūsu piekrišanu vai iekšā 
					saskaņā ar citiem juridiskajiem pamatiem. Plašāku informāciju skatiet mūsu sīkfailu politikā.</li>
				<li>IP, no kura tiek izveidots savienojums, izmantotās ierīces veids un īpašības, versija 
					operētājsistēma, pārlūkprogrammas veids, valoda, datums, valsts, pieprasījuma laiks, 
					cita starpā URL no tā, no kura nākat, URL, uz kuru dodaties, vai izmantotais mobilais tīkls.</li>
				<li>Pakalpojuma lietošanas dati un iespējamās kļūdas, kas konstatētas tā lietošanas laikā.</li>
				<li>Turklāt funkcija Remove Background izmanto Google Analytics, Google, LLC nodrošināto analītisko pakalpojumu. 
					domicils ir Amerikas Savienotajās Valstīs, galvenā mītne atrodas 1600 Amphitheatre Parkway, Mountain View, California 94043. 
					Šo pakalpojumu sniegšanai viņi izmanto sīkfailus, kas apkopo informāciju, tostarp lietotāja IP adresi, 
					ko Google pārsūtīs, apstrādās un uzglabās saskaņā ar noteikumiem, kas noteikti tīmeklī www.google.com. 
					Ieskaitot iespējamu minētās informācijas nosūtīšanu trešajām personām juridisku prasību dēļ vai 
					kad minētās trešās puses apstrādā informāciju Google vārdā.</li>
			</ul>
			<p>Jebkurā gadījumā varat atspējot Google Analytics sīkfailus <a href="{externalLink: disableGoogleAnalyticsLink}">šeit</a>.</p>

			<h5>2.2. Tas, kuru jūs brīvprātīgi sniedzat</h5>
			<p>Šajā informācijā būs:</p>
			<ul>
				<li>Visi dati ir obligāti.</li>
				<li>Tā, kas nepieciešama funkcijai Remove Background, lai pabeigtu reģistrāciju tīmeklī: vārds un uzvārds, adrese un e-pasta adrese, cita starpā.</li>
				<li>Visi dati ir obligāti.</li>
				<li>Informācija neatkarīgi no tā, vai tā ir vai nav, lai pabeigtu pakalpojuma līguma noslēgšanu, piemēram, jūsu e-pasta adrese un kredītkartes vai debetkartes numurs.</li>
				<li>Personiskā vai neinformācija, kas var ietvert ziņojumos, kas nosūtīti, izmantojot Pakalpojumā izveidotos saziņas vai viedokļu kanālus, 
					piemēram, jūsu vārds un e-pasts.</li>
			</ul>

			<h5>2.3. Tādu, ko nodrošina trešās puses</h5>
			<p>Šajā informācijā būs:</p>
			<ul>
				<li>Tā, ko nodrošina maksājumu sistēmas vai kredītkaršu apstrādātāji, piemēram, pirkuma laiks vai tā summa.</li>
			</ul>


			<h3>3. Tiesības un mērķi</h3>
			<p>Informējam, ka veidlapu aizpildīšana ir brīvprātīga. Taču, ja neaizpildāt obligātos laukus 
				(parasti atzīmēts ar zvaigznīti), dažu Pakalpojuma funkciju izmantošana nebūs iespējama vai būs ierobežota.<br>
				Jūsu sniegtie personas dati tiks iekļauti un apstrādāti fona noņemšanas ārstēšanas darbību reģistrā. 
				lai varētu izpildīt jūsu pieprasījumus, sniegt pieprasīto pakalpojumu un informēt jūs par jautājumiem, kas saistīti ar darbību 
				par uzņēmumu un tā pakalpojumiem.<br>
				Jūs jebkurā laikā varat izmantot tiesības piekļūt, labot, dzēst, ierobežot savu ārstēšanu, 
				iebildumi un jūsu personas datu pārnesamība pa e-pastu, kas adresēts uz: {supportLink} vai pasta adrese: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barselona, Spānija.<br>
				Abos gadījumos jums ir jānorāda savs vārds un uzvārds, kā arī DNI vai valsts ID kopija, ja nepieciešams.<br>
				Gadījumā, ja esat devis piekrišanu konkrētam mērķim, jums ir tiesības jebkurā laikā atsaukt piekrišanu, 
				neietekmējot ārstēšanas likumību, pamatojoties uz piekrišanu pirms tās atsaukšanas.<br>
				Turklāt, ja uzskatāt, ka ir problēmas ar to, kā Remove Background apstrādā jūsu datus, 
				varat vērsties ar savām sūdzībām attiecīgajā <a href="{knowYourRightsLink}">datu aizsardzības iestādē</a>, kas ir <a href="{aepdLink}">Spānijas datu aizsardzības aģentūra</a>. 
				tas, kas norādīts Spānijas gadījumā.</p>


			<h3>4. Vecums</h3>
			<p>Attiecībā uz tiešsaistes pakalpojuma izmantošanu jūs apliecināt, ka esat pilngadīgs un jums ir nepieciešamās juridiskās 
				spēju ievērot šo līgumu un izmantot vietni saskaņā ar tās noteikumiem un nosacījumiem, kurus jūs pilnībā 
				saprast un atzīt.<br>
				Jūs apliecināt, ka visa informācija, ko sniedzat, lai piekļūtu Pakalpojumam pirms tā izmantošanas un tās laikā, ir patiesa, pilnīga 
				un precīzi.</p>


			<h3>5. Datu izmantošana</h3>
			<p>Fona noņemšana izmantos apkopotos datus, lai:</p>
			<ul>
				<li>Pārvaldiet un atjauniniet Pakalpojumu (juridiskais pamats ir mūsu likumīgās intereses uzturēt un uzturēt Pakalpojumu). 
					atjaunināts un labā stāvoklī).</li>
				<li>Atrisiniet uzdotos jautājumus (juridiskais pamats ir mūsu likumīgās intereses izskatīt pieprasījumus un 
					mūsu lietotāju šaubas).</li>
				<li>Apstrādājiet veiktos maksājumus (līgums ir juridiskais pamats).</li>
				<li>Sniedziet līgumā paredzēto pakalpojumu (līgums ir juridiskais pamats).</li>
				<li>Uzturēt Pakalpojuma drošību, izmeklēt nelikumīgas darbības, nodrošināt mūsu noteikumu un nosacījumu izpildi un
					palīdzēt valsts drošības spēkiem to iespējamās izmeklēšanas ietvaros (juridiskais pamats ir mūsu 
					leģitīmas intereses garantēt un uzturēt Pakalpojuma un tā lietotāju drošību).</li>
			</ul>
			<p>Fona noņemšana neizmanto automatizētus lēmumus, lai gan var ģenerēt pamata lietotāju profilus, 
				juridiskais pamats ir mūsu likumīgās intereses komerciālos nolūkos un personalizētu piedāvājumu nodrošināšana.<br>
				Tāpat funkcija Remove Background var izmantot lietotāja informāciju apkopotu un anonīmu datu veidā, lai to parādītu trešajām pusēm. 
				Jūs varat arī kopīgot statistiku un demogrāfisko informāciju par lietotājiem un viņu Pakalpojuma lietošanu ar trešajām pusēm. 
				Taču nekas no tā neļaus šīm trešajām pusēm jūs personīgi identificēt.</p>

			<h5>5.1. E-pastos un kontaktu veidlapās</h5>
			<p>Vietnei ir SSL šifrēšana, kas ļauj lietotājam droši nosūtīt savus personas datus, izmantojot standarta saziņas veidlapas.<br>
				Apkopotie personas dati tiks pakļauti automatizētai apstrādei un iekļauti attiecīgajās datnēs 
				no apstrādes darbību ieraksta un kuras īpašnieks ir Remove Background.</p>
			<p>Šajā nozīmē:</p>
			<ul>
				<li>Mēs saņemsim jūsu IP adresi, kas tiks izmantota, lai pārbaudītu ziņojuma izcelsmi, lai piedāvātu jums atbilstošu 
					ieteikumus (piemēram, sniegt informāciju pareizajā valodā) un atklāt iespējamos pārkāpumus 
					(piemēram, iespējamie mēģinājumi veikt kiberuzbrukumu Pakalpojumam), kā arī dati, kas saistīti ar jūsu ISP.</li>
				<li>Tāpat jūs varat sniegt mums savus datus pa tālruni, e-pastu un citiem norādītajiem saziņas līdzekļiem.</li>
			</ul>
			<p>Attiecībā uz izmantotajiem maksāšanas līdzekļiem:</p>
			<ul>
				<li>Mūsu maksājumu pakalpojumu sniedzēji, kas maksā par mūsu pakalpojumu sniegšanu, ir kredītkarte vai debetkarte. 
					Pakalpojums vai tā darbinieki nekad nevarēs piekļūt bankas datiem (piemēram, kredītkartes numuram) 
					ko lietotājs kā klients nodrošinās šīm trešajām personām.</li>
			</ul>


			<h3>6. Datu saglabāšana</h3>
			<p>Tālāk ir norādīts, cik ilgi Pakalpojumā apstrādātie dati tiek glabāti:</p>
			<ul>
				<li>Sadalītie dati tiks saglabāti bez dzēšanas perioda.</li>
				<li>
					Klienta dati tiks glabāti tik ilgi, cik nepieciešams, un tos var glabāt līdz:
					<ul>
						<li>5 gadi saskaņā ar 1. Civilkodeksa 1964.g (personas darbības bez īpaša termiņa).</li>
						<li>6 gadi saskaņā ar 1. Komerclikuma 30. pantu (piemēram, grāmatvedības grāmatiņas vai rēķini).</li>
					</ul>
				</li>
				<li>Lietotāju dati tiks glabāti ne ilgāk kā 12 mēnešus, lai viņi varētu izpildīt pieprasījumus.</li>
			</ul>


			<h3>7. Dati tiek kopīgoti ar trešajām pusēm</h3>
			<p>Ir trešās puses, kas pārvalda daļu no Pakalpojuma.<br>
				Lai noņemtu fonu, viņiem ir jāievēro šī konfidencialitātes politika, ja tā ir piemērojama. Tomēr Remove Background nebūs atbildīgs par atbilstību minētajai politikai.<br>
				Noteiktos apstākļos funkcija Remove Background var koplietot, izmantot vai saglabāt ar trešajām pusēm jebkādu savākto personisko informāciju:</p>
			<ul>
				<li>Lai nodrošinātu Pakalpojumu:</li>
			</ul>
			<p>Pakalpojumu sniedzēji, kas veic funkcijas mūsu vārdā, piemēram, maksājumu pakalpojumus, tīmekļa mitināšanu, biznesa analīzi, klientu apkalpošanu vai tīmekļa mārketingu. Šie pakalpojumu sniedzēji var vākt un piekļūt informācijai, kas tiem nepieciešama savu funkciju veikšanai, taču viņiem nav atļauts kopīgot vai izmantot informāciju citiem mērķiem.</p>
			<ul>
				<li>Lai sadarbotos ar kompetentajām iestādēm:</li>
			</ul>
			<p>Ja mēs uzskatām, ka tas ir pamatoti nepieciešams, lai izpildītu jebkuru likumu, juridisku procesu vai likumīgas intereses. Jebkurā gadījumā mēs sniegsim tikai stingri nepieciešamo informāciju.</p>


			<h3>8. Drošības pasākumi</h3>
			<p>Remove Background veic visus nepieciešamos tehniskos un organizatoriskos pasākumus
				aizsargātu savāktās personiskās un nepersoniskās informācijas drošību un integritāti. 
				Gan pret nesankcionētu piekļuvi, gan tās nejaušu pārveidošanu, nozaudēšanu vai iznīcināšanu.<br>
				Jebkurā gadījumā, Remove Background nevar garantēt absolūtu savāktās informācijas drošību, 
				tāpēc jums vienmēr ir jāsadarbojas un jāizmanto veselais saprāts attiecībā uz kopīgoto informāciju.<br>
				Jūs saprotat un atzīstat, ka personiskā un nepersoniskā informācija var būt arī pēc dzēšanas 
				paliek redzams kešatmiņā vai ja citi lietotāji to ir kopējuši vai saglabājuši.</p>


			<h3>9. Privātuma politikas izmaiņas</h3>
			<p>Mēs varam atjaunināt šo konfidencialitātes politiku nākotnē. Mēs jūs informēsim par izmaiņām, nosūtot paziņojumu uz norādīto e-pasta adresi un/vai ievietojot paziņojumu labi redzamā vietā mūsu vietnē.</p>


			<h3>10. Sazināties ar</h3>
			<p>Ja jums ir jautājumi par šo konfidencialitātes politiku, sazinieties ar mums:</p>
			<p>E-pasts: {supportLink}<br> 
				Adrese: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barselona, Spānija.</p>
		`
	},
	gdpr: {
		lastUpdate: 'Pēdējo reizi atjaunināts: 2024. gada 10. jūnijā',
		content: `
			<h3>1. Kas ir atbildīgs un kā ar viņiem sazināties?</h3>
			<p>Šīs vietnes pārzinis ir Remove Background S.L ar adresi Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barselona, Spānija.</p>
			<p>Varat sazināties ar viņu pa e-pastu vietnē {supportLink}.</p>

			<h3>2. Kādi dati tiek vākti?</h3>
			<p>
				Mēs automātiski ievācam datus, izmantojot sīkfailus, ko ielādējam jūsu ierīcē, tostarp analīzi. 
				Mēs arī apkopojam IP, no kuras tiek izveidots savienojums, izmantotās ierīces veidu un tās īpašības, 
				operētājsistēmas versija, pārlūkprogrammas veids, valoda, datums, valsts, pieprasījuma laiks, 
				URL, no kura nākat, URL, uz kuru dodaties, vai izmantotais mobilais tīkls, cita starpā.<br>
				Lietotājs brīvprātīgi sniedz mums kādu informāciju, piemēram, savu vārdu un uzvārdu, e-pastu vai bankas informāciju 
				lai varētu sazināties ar mums, reģistrēties pakalpojumam vai iegādāties abonementu.
			</p>

			<h3>3. Kam tiek izmantoti apkopotie dati?</h3>
			<p>
				Pakalpojums izmantos savāktos datus, cita starpā, lai administrētu un atjauninātu pakalpojumu, atbildētu uz jūsu pieprasījumiem, 
				nosūtīt jums mūsu biļetenus un reklāmas piedāvājumus pa e-pastu, pārvaldīt jūsu reģistrāciju platformā, pārvaldīt un nodrošināt 
				ar jūsu abonementu saistītos pakalpojumus, apstrādāt jūsu veiktos maksājumus un izrakstīt atbilstošos rēķinus, 
				uzturēt Pakalpojuma drošību, izmeklēt nelikumīgas darbības, nodrošināt mūsu noteikumu un nosacījumu izpildi un 
				palīdzēt valsts drošības spēkiem un struktūrām to iespējamās izmeklēšanas ietvaros.
			</p>

			<h3>4. Cik ilgi tie tiek glabāti?</h3>
			<ul>
				<li>Sadalītie dati tiks saglabāti bez dzēšanas perioda.</li>
				<li>
					Klienta dati tiks glabāti tik ilgi, cik nepieciešams, un tos var glabāt līdz:
					<ul>
						<li>5 gadi saskaņā ar 1. Civilkodeksa 1964.g (personas darbības bez īpaša termiņa).</li>
						<li>6 gadi saskaņā ar 1. Komerclikuma 30. pantu (piemēram, grāmatvedības grāmatiņas vai rēķins).</li>
					</ul>
				</li>
				<li>Lietotāju dati tiks glabāti ne ilgāk kā 12 mēnešus, lai izpildītu viņu pieprasījumus.</li>
				<li>Lietotāja dati, ko Pakalpojums augšupielādē sociālo tīklu lapās un profilos, tiks saglabāti no brīža, kad lietotājs piedāvā savu piekrišanu, līdz viņš to atsauc.</li>
			</ul>

			<h3>5. Kādas ir jūsu kā lietotāja tiesības?</h3>

			<p>
				Piekļuves tiesības: ietekmētajai pusei ir tiesības saņemt apstiprinājumu no datu pārziņa par to 
				vai netiek apstrādāti viņu personas dati.
			</p>
			<p>
				Tiesības uz labošanu: ietekmētajai pusei ir tiesības bez nepamatotas kavēšanās saņemt no datu pārziņa 
				tādu personas datu labošanu, kas ir neprecīzi un skar viņu tieši. Tāpat to darīs ieinteresētā puse 
				ir tiesības aizpildīt nepilnīgus personas datus, tostarp ar papildu deklarācijas palīdzību.
			</p>
			<p>
				Tiesības uz dzēšanu: skartajai pusei ir tiesības bez nepamatotas kavēšanās saņemt no datu pārziņa datu dzēšanu. 
				personas datiem, kas attiecas uz viņu.
			</p>
			<p>
				Tiesības ierobežot datu apstrādi: ir panākt, ka atbildīgā persona ierobežo jūsu datu apstrādi, 
				lai gan tās īstenošanai ir divi aspekti: 1) Ja jūs apstrīdat savu personas datu precizitāti, laika posmā, kas ļauj 
				atbildīgā persona, lai to pārbaudītu, un 2) ja esat iebildis pret savu personas datu apstrādi, ko atbildīgā persona 
				veic, pamatojoties uz likumīgām interesēm vai sabiedrības interešu misiju, savukārt atbildīgā persona pārbauda, vai šie iemesli 
				dominē pār tavējo.
			</p>
			<p>
				Tiesības uz datu pārnesamību: skartās puses tiesības saņemt personas datus, kas attiecas uz viņu, 
				ko viņš ir sniedzis datu pārzinim strukturētā formātā, plaši lietojamā un mehāniski nolasāmā veidā, un 
				pārsūtīt tos citam pārzinim, to neliedzot pārzinis, kuram tie tika sniegti.
			</p>
			<p>
				Šajā ziņā ieinteresētajai personai būs tiesības uz personas datu pārsūtīšanu tieši no pārziņa 
				kontrolierim, ja tas ir tehniski iespējams.
			</p>

			<h3>6. Kā jūs varat izmantot savas tiesības?</h3>

			<p>
				Jūs varat izmantot savas tiesības uz personas datiem jebkurā laikā, nosūtot e-pastu uz: {supportLink} vai pasta adresi: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barselona, Spānija. Abos gadījumos jums ir jāidentificējas ar savu vārdu un uzvārdiem, 
				kā arī jūsu DNI vai valsts ID kopija, ja nepieciešams.<br>
				Turklāt, ja uzskatāt, ka ir problēmas ar to, kā Remove Background apstrādā jūsu datus, varat virzīt savas pretenzijas. 
				atbilstošajai <a href="{knowYourRightsLink}">datu aizsardzības iestādei</a>, kas ir <a href="{aepdLink}">Spānijas datu aizsardzības aģentūra</a> 
				tas, kas norādīts Spānijas gadījumā.
			</p>

			<h3>7. Vai ir veikti drošības pasākumi?</h3>
			<p>
				Pakalpojums veic visus nepieciešamos tehniskos un organizatoriskos pasākumus, lai aizsargātu personas drošību un integritāti 
				un apkopotā nepersoniskā informācija. Gan pret nesankcionētu piekļuvi, gan pret nejaušu pārveidošanu, nozaudēšanu vai iznīcināšanu.<br>
				Jebkurā gadījumā Pakalpojums nevar garantēt absolūtu savāktās informācijas drošību, tāpēc jums ir jāsadarbojas un 
				vienmēr izmantojiet veselo saprātu attiecībā uz kopīgoto informāciju.<br>
				Jūs saprotat un atzīstat, ka pat pēc dzēšanas personiskā un nepersoniskā informācija var palikt skatāma kešatmiņā vai 
				ja tos kopē vai saglabā citi lietotāji.
			</p>

			<h3>8. Vai notiek personas datu pārsūtīšana vai starptautiska pārsūtīšana?</h3>

			<p>
				Mēs nepārsūtām datus vai starptautiskus pārskaitījumus. Tomēr ir trešās puses, kas pārvalda daļu no Pakalpojuma 
				kas mums ir jāievēro mūsu Privātuma politika, ciktāl tā attiecas uz viņiem un ka viņiem ir sava. 
				Šīs trešās puses ir pakalpojumu sniedzēji, kas veic funkcijas mūsu vārdā, piemēram, tīmekļa mitināšanu, 
				analītikas uzraudzība vai tīmekļa izstrāde.<br>
				Tāpat, ja uzskatām, ka tas ir pamatoti nepieciešams, lai apmierinātu kādu likumu, tiesisku procesu vai leģitīmas intereses. 
				Jebkurā gadījumā mēs sniegsim tikai stingri pieprasīto informāciju.
			</p>`
	},
	cookiesPolicy: {
		lastUpdate: 'Pēdējo reizi atjaunināts: 2024. gada 21. jūnijā',
		content: `
			<h3>Kopsavilkums</h3>
			<ul>
			    <li>Izmantotie sīkfaili: <strong>pašu un trešās puses sīkfaili</strong></li>
			    <li>Vai tos izmanto statistikas iegūšanai? <strong>Jā, pamatojoties uz mūsu likumīgajām interesēm labāk pārvaldīt pakalpojumu.</strong></li>
			    <li>Trešo pušu pakalpojumi, kas instalē sīkfailus, izmantojot šo vietni: <strong>Google, Google Analytics, Cloudflare un Stripe.</strong></li>
			</ul>

			<h3>Kā konfigurēt un atspējot sīkfailus</h3>
			<p>
			    Jūs varat atļaut, bloķēt vai dzēst sīkfailus, kas instalēti jūsu ierīcē no tīmekļa pārlūkprogrammas. Ja jūs neatļaujat sīkfailu uzstādīšanu savā ierīcē, 
			    pārlūkošanas pieredze var pasliktināties. Tālāk ir norādīts, kā konfigurēt sīkfailus katrā pārlūkprogrammā:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Veidi un lietojumi</h3>
			<p>Pakalpojums izmanto paša un trešo pušu sīkfailus, lai uzlabotu pārlūkošanu, nodrošinātu pakalpojumu un iegūtu statistiku par vietnes lietošanu.</p>

			<h3>2. Kas ir sīkfails un kādam nolūkam to izmanto?</h3>
			<p>
			    Sīkfails ir teksta fails, kas tiek nosūtīts uz jūsu datora, mobilā tālruņa vai planšetdatora tīmekļa pārlūkprogrammu un tiek izmantots, lai saglabātu un izgūtu informāciju par
			    pārlūkošana ir pabeigta. Piemēram, lai atcerētos savu lietotājvārdu un paroli vai profila preferences.
			</p>

			<h3>3. Kādi sīkfailu veidi pastāv?</h3>
			<p>Atbilstoši tam, kas tos pārvalda:</p>
			<ul>
			    <li>pašu sīkfaili; tie tiek nosūtīti uz jūsu pārlūkprogrammu no mūsu pašu aprīkojuma vai tīmekļa domēniem.</li>
			    <li>Trešās puses sīkfaili; tie tiek nosūtīti uz jūsu pārlūkprogrammu no aprīkojuma vai tīmekļa domēniem, kurus mēs nepārvaldām tieši, bet no trešās personas, piemēram, Google.</li>
			</ul>
			<p>Atbilstoši tam, cik ilgi tie paliek aktīvi, ir:</p>
			<ul>
			    <li>Sesijas sīkfaili; tie paliek jūsu pārlūkprogrammas sīkfailu failā, līdz pametat vietni, tāpēc neviens nepaliek jūsu ierīcē.</li>
			    <li>Pastāvīgie sīkfaili; tie paliek jūsu ierīcē, un mūsu vietne tos nolasa katru reizi, kad veicat jaunu apmeklējumu. Šīs sīkdatnes pārstāj darboties pēc noteikta datuma.</li>
			</ul>
			<p>Visbeidzot, atbilstoši to mērķim, mums ir:</p>
			<ul>
			    <li>Tehniskie sīkfaili; tie uzlabo pārlūkošanu un vietnes pareizu darbību.</li>
			    <li>Personalizēšanas sīkfaili; tie ļauj piekļūt pakalpojumam ar iepriekš noteiktiem raksturlielumiem, pamatojoties uz vairākiem kritērijiem.</li>
			    <li>Analītikas sīkfaili; tie ļauj izmērīt un statistiski analizēt sniegtā pakalpojuma izmantošanu.</li>
			</ul>
			<p>Trešās puses sīkfailu saraksts, ko izmanto <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: viņu sīkfaili (NID vai CONSENT) ļauj personalizēt to, kā reklāmas tiek rādītas ārpus Google, vai saglabāt informāciju.
			        piemēram, vēlamā valoda, kad tiek rādīti meklēšanas rezultāti.<br><a href="{externalLink: googleCookieTypes}">Plašāka informācija</a> par sīkfailu veidiem, ko Google izmanto savos dažādos pakalpojumos.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: to sīkfaili (piemēram, _ga) ļauj saskaitīt, cik reižu lietotājs apmeklē vietni, kā, kad un no kurienes.<br>
			        Jebkurā gadījumā varat atspējot Google Analytics sīkfailus <a href="{externalLink: disableGoogleAnalytics}">šeit</a>.
			    </li>
			    <li>Cloudflare: lai uzzinātu par Cloudflare sīkfailu politiku un lietojumu, noklikšķiniet uz <a href="{externalLink: cloudflareCookiesPolicy}">šīs saites</a>.</li>
			    <li>Stripe: atrodiet informāciju <a href="{externalLink: stripeCookiesPolicy}">šeit</a> par Stripe sīkfailu politiku un lietojumu.</li>
			</ul>
		`
	}
};
